import SettingField from 'components/Fields/ReduxForm/SettingField'
import {reduxForm, Field, FieldArray, getFormValues, isDirty} from 'redux-form'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import {connect} from 'react-redux'
import styles from './ItemForm.css'
import {
  onClickCancel,
  deleteItem,
  showDeleteModal,
  hideDeleteModal,
  onCancelCOGSModal,
  onCancelItemInventoryAlertModal,
  onCancelItemVariantModal,
  onClickCreateNewCategory,
  onCancelCreateNewCategory,
  onConfirmCreateNewCategory,
  onConfirmItemVariantModal,
  onConfirmItemInventoryAlertModal,
  onConfirmCOGSModal
} from 'actions/library/item'
import UploadImage from 'components/Fields/ReduxForm/UploadImage'
import {Creatable} from 'react-select'
import 'react-select/dist/react-select.css'
import ItemVariant from './ItemVariant'
import ItemInventoryAlert from './ItemInventoryAlert'
import COGS from './COGS'
import ItemTax from './ItemTax'
import ItemModifier from './ItemModifier'
import ItemVariantModal from './ItemVariantModal'
import ItemInventoryAlertModal from './ItemInventoryAlertModal'
import COGSModal from './COGSModal'
import LibraryDeleteModal from 'components/LibraryDeleteModal'
import CreateCategoryModal from './CreateCategoryModal'
import SaveToAllOutletsModal from './SaveToAllOutletsModal'
import WarningLabel from './WarningLabel'
import * as mpLibrary from 'mixpanel/library/list'
import {Link} from 'react-router'
import validator from 'validator'

const tooltipDeleteBtn = (
  <Popover id='popover-trigger-hover-focus'>
    This item cannot be deleted because it has been associated with a Recipe.
    Please first delete the Recipe and try again.
  </Popover>)

const validate = (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Please enter a value'
  } else if (values.name.length > 100) {
    errors.name = 'Name too long'
  }

  if (!values.amount || isNaN(values.amount)) {
    errors.amount = 'Please enter a value'
  } else if (values.amount <= 0) {
    errors.amount = 'Please enter a value > 0'
  } else if (values.amount > 100 && values.typeAmount) {
    errors.amount = 'Please input Item amount less than 100%'
  } else if (values.amount > 100000000000 && !values.typeAmount) {
    errors.amount = 'Please input Item amount less than 100.000.000.000'
  }

  const itemVariantsErrors = []
  if (values.item_variants) {
    values.item_variants.forEach((iv, index) => {
      const memberError = {}
      if (!iv.name && values.item_variants.length > 1) {
        memberError.name = 'Please enter a value'
      }
      if (!iv.in_stock && '' + iv.in_stock !== '0') {
        memberError.in_stock = 'Stock is required'
      } else if (!validator.isNumeric('' + iv.in_stock)) {
        memberError.in_stock = 'Please enter a valid Number'
      } else if (iv.in_stock > 999999) {
        memberError.in_stock = 'In stock must be less than 6 digits'
      }
      if (iv.price > 99999999999) {
        memberError.price = 'Price must be less than 99.999.999.999'
      }
      if (!iv.cogs && '' + iv.cogs !== '0') {
        memberError.cogs = 'Avg. cost is required'
      }
      if (iv.cogs > 99999999999) {
        memberError.cogs = 'Avg. Cost must be less than 11 digits'
      }
      if (Object.keys(memberError).length > 0) {
        itemVariantsErrors[index] = memberError
      }
    })
  }
  if (itemVariantsErrors.length) {
    errors.item_variants = itemVariantsErrors
  }

  return errors
}

class RenderSelectField extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectInstance: 1
    }
  }
  onChangeSelect = (newval) => {
    const {input: {value, onChange}, meta: {dispatch}, options, categories} = this.props
    let isNewCategory = true
    options.forEach((cat) => {
      if (cat.value === newval.value && typeof newval.value === 'number') {
        isNewCategory = false
      }
    })
    if (isNewCategory) {
      dispatch(onClickCreateNewCategory(newval.value, categories, value))
      onChange(newval.value)
    } else {
      onChange(newval.value)
    }
  }
  render () {
    const {input: {value}, placeholder, options} = this.props
    const selectProps = {
      addLabelText: '{label} (create new)',
      value,
      className: styles['select-dropdown'],
      placeholder,
      onChange: this.onChangeSelect,
      options,
      clearable: false,
      backspaceRemoves: false,
      promptTextCreator: (label) => (`${label} (create new)`),
      onClose: () => { this.setState({selectInstance: 1 - this.state.selectInstance}) }
    }
    // TODO HACK buat nyamain behaviour kode lama:
    // harus dalam html tag yang beda
    // harus dua komponen yang beda
    if (this.state.selectInstance === 1) {
      return <div>
        <Creatable {...selectProps} /></div>
    } else {
      return <span><Creatable
        {...selectProps}
      /></span>
    }
  }

}

class ItemForm extends React.Component {
  constructor (props) {
    super(props)
    this.scrollArea = null
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.mustScrollTop) {
      this.scrollArea.scrollTop = 0
    }
  }
  render () {
    let {
      itemDetail,
      handleSubmit,
      categories,
      modifiers,
      taxes,
      itemForm,
      showDeleteModal,
      isSubmittingForm,
      outlets
    } = this.props
    const uploadImagePlaceholder = (itemForm && itemForm.name) ? itemForm.name.substring(0, 2) : ''
    return (
      <form onSubmit={handleSubmit} className='full-height'>
        <div ref={(a) => { this.scrollArea = a }} className={`${styles['item-fieldset']}`}>
          <div className='row'>
            <Field component='input' type='hidden' name='id' />
            <div className='col-lg-2 col-md-3 col-sm-3'>
              <Field
                name='image.url'
                component={UploadImage}
                placeholder={uploadImagePlaceholder}
                className={styles['upload-image']}
                backgroundColor={itemDetail ? itemDetail.background_color : null}
              />
            </div>
            <div className='col-lg-10 col-md-9 col-sm-9'>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='form-group'>
                    <Field
                      component={SettingField}
                      className='form-control'
                      name='name'
                      maxLength='40'
                      placeholder='Item Name'
                      type='text'
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='form-group'>
                    <Field
                      component={RenderSelectField}
                      className='selectCategories'
                      name='category_id'
                      options={this._formatCategories(categories)}
                      categories={categories}
                      onChange={this._onChangeCategories}
                      placeholder='Select an option'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`row ${styles['margin-top-30']}`}>
            <div className='col-lg-12'>
              <div className='form-group' style={{marginBottom: 0}}>
                <label className={`${styles['label-input']}`}>
                  Price
                </label>
                <ItemVariant />
              </div>
            </div>
          </div>
          <div className={`row ${styles['margin-top-30']}`}>
            <div className='col-lg-12'>
              {itemDetail && <div className='form-group'>
                <label className={`${styles['label-input']}`}>
                  Inventory
                </label>
                <ItemInventoryAlert disabled={itemDetail.is_recipe} classButton={`${styles['disabled-button']}`} />
                {!itemDetail.is_recipe && <WarningLabel
                  content='Item stock can not be changed after saving the item, so please make sure that it is correct!'
                  type='info'
                />}
                {itemDetail.is_recipe && <WarningLabel
                  type='warning'
                  link
                >
                  This item can not be tracked because it has a recipe. Use the <Link to='/ingredient/recipes'><i>Ingredient Page</i></Link> to manage recipes.
                </WarningLabel>}
              </div>}
            </div>
          </div>
          <div className={`row ${styles['margin-top-30']}`}>
            <div className='col-lg-12'>
              <div className='form-group'>
                <label className={`${styles['label-input']}`}>
                  Cost
                </label>
                {itemDetail && <COGS disabled={itemDetail.is_recipe} classButton={`${styles['disabled-button']}`} />}
              </div>
            </div>
          </div>
          {modifiers.length > 0 && <div className={`row ${styles['margin-top-30']}`}>
            <div className='col-lg-12'>
              <div className='form-group'>
                <label className={`${styles['label-input']}`}>
                  Modifier
                </label>
                <FieldArray
                  name='active_modifiers'
                  component={ItemModifier}
                  modifiers={modifiers}
                />
              </div>
            </div>
          </div>}
          {
            taxes.length > 0 && <div className={`row ${styles['margin-top-30']}`}>
              <div className='col-lg-12'>
                <div className='form-group'>
                  <label className={`${styles['label-input']}`}>
                    Assigned Tax
                  </label>
                  <FieldArray
                    comment='{/*fka active_taxes */}'
                    itemDetail={itemDetail}
                    name='taxes'
                    component={ItemTax}
                    taxes={taxes}
                  />
                </div>
              </div>
            </div>
          }
          <div className={`row ${styles['margin-top-30']}`}>
            <div className='col-lg-12'>
              <div className='form-group'>
                <label className={`${styles['label-input']}`}>
                  Description
                </label>
                <Field
                  component='textarea'
                  className='form-control'
                  placeholder='Item Description'
                  maxLength='70'
                  name='description'
                  type='text'
                  rows='3'
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          {itemDetail && itemDetail.id && <span className='pull-left'>
            {itemDetail && !itemDetail.is_recipe
              ? <button className='btn btn-danger no-outline' onClick={this._onClickDelete} disabled={isSubmittingForm}>
                <i className='fa fa-trash' />
              </button>
              : <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={tooltipDeleteBtn}>
                <button className={`btn ${styles['disabled-button']}`} onClick={(e) => e.preventDefault()}>
                  <i className='fa fa-trash' />
                </button>
              </OverlayTrigger>
            }
          </span>}
          <span className='pull-right'>
            <button className='btn btn-default no-outline' type='button' style={{'margin-right': '10px'}} onClick={this._onClickCancel} disabled={isSubmittingForm}>
             Cancel
            </button>
            {itemForm && !itemForm.id && outlets && outlets.length > 1 && <button className='btn btn-primary no-outline' type='button' style={{'margin-right': '10px'}} onClick={handleSubmit(this._onSubmitCreateAllOutlet)} disabled={isSubmittingForm}>
              Save to All Outlets
            </button>}
            <button className='btn btn-primary no-outline' type='submit' onClick={handleSubmit(this._onSubmitSave)} disabled={isSubmittingForm}>
              Save
            </button>
          </span>
        </div>
        <ItemVariantModal onSubmit={this._onSaveVariant} />
        <ItemInventoryAlertModal onSubmit={this._onSaveTrackInv} />
        <SaveToAllOutletsModal />
        <COGSModal onSubmit={this._onSaveCOGS} />
        {itemDetail && itemDetail.id && <LibraryDeleteModal
          name={itemDetail.name}
          onHide={this._onHideDeleteModal}
          showDeleteModal={showDeleteModal}
          title='Item'
          onDelete={this._confirmDelete}
        />}
        <CreateCategoryModal
          dispatch={this.props.dispatch}
          newCategory={this.props.newCategory}
          show={this.props.showNewCategoryModal}
          onCancel={this._onCancelCreateCategoryModal}
          onConfirm={this._onConfirmCreateCategoryModal}
        />
      </form>
    )
  }
  _onSaveVariant = (value) => {
    const {dispatch, isDirtyForm} = this.props
    if (isDirtyForm) {
      dispatch(onConfirmItemVariantModal(value))
    } else {
      dispatch(onCancelItemVariantModal())
    }
  }
  _onSaveTrackInv = (value) => {
    const {dispatch, itemForm, isDirtyForm} = this.props
    let isTrack = false
    itemForm.item_variants.forEach((iv) => {
      if (iv.track_stock) {
        isTrack = true
      }
    })
    // HACKY CODE
    // ini hack untuk yang FD-1471, karena validasi form entah hilang ketika melakukan remove array dan push kembali array yang kemungkinan sama
    // karena redux form tidak melakukan validasi kembali ketika proses push array baru berlangsung, untuk mengatasi keterbatasan itu,
    // maka dibuatlah logic:
    // jika tidak memberikan perubahan apa apa terhadap form maka tidak usah melakukan rangkaian confirm, cucup tutup modal saja
    if (isDirtyForm || !isTrack) {
      dispatch(onConfirmItemInventoryAlertModal(value, itemForm))
    } else {
      dispatch(onCancelItemInventoryAlertModal())
    }
  }
  _onSaveCOGS = (value) => {
    const {dispatch, isTrack, isDirtyForm} = this.props
    if (isDirtyForm || !isTrack) {
      dispatch(onConfirmCOGSModal(value, isTrack))
    } else {
      dispatch(onCancelCOGSModal())
    }
  }

  _onCancelCreateCategoryModal = () => {
    const {dispatch, previousCategories, previousCategoryId} = this.props
    dispatch(onCancelCreateNewCategory(previousCategories, previousCategoryId))
  }

  _onConfirmCreateCategoryModal = () => {
    const {dispatch, newCategory} = this.props
    dispatch(onConfirmCreateNewCategory(newCategory))
  }

  _onHideDeleteModal = () => {
    const {dispatch} = this.props
    dispatch(hideDeleteModal())
  }

  _confirmDelete = () => {
    const {dispatch, itemDetail, items, search} = this.props
    mpLibrary.libraryItemDelete({item: itemDetail})
    dispatch(deleteItem(itemDetail, items, search))
  }

  _formatCategories = (categories) => {
    let formatCategory = []
    categories.map(function (category) {
      if (category.id > 0) {
        formatCategory.push({value: category.id, label: category.name})
      }
    })
    return formatCategory
  }

  _onClickDelete = (e) => {
    const {dispatch} = this.props
    dispatch(showDeleteModal())
    e.preventDefault()
    e.stopPropagation()
  }

  _onClickCancel = (e) => {
    this.props.dispatch(onClickCancel())
    e.preventDefault()
    e.stopPropagation()
  }

  _onSubmitCreateAllOutlet = (values) => {
    this.props.onSubmit({...values, action: 'save_to_all_outlet'})
  }

  _onSubmitSave = (values) => {
    this.props.onSubmit({...values, action: 'save'})
  }

  _onChangeSwitch = () => {
    this.props.onChangeSwitch()
  }

  _onChangeCategories = (val, newVal) => {

  }

  _findUncategorized = (categories) => {
    let idUncategory
    categories.map(function (category, index) {
      if (category.name === 'Uncategorized') {
        idUncategory = category.id
      }
    })
    return idUncategory
  }
}

ItemForm.propTypes = {
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func
}

function mapStateToProps (state) {
  let {item} = state.library
  return {
    outlets: item.outlets,
    modifiers: item.modifiers,
    itemDetail: item.itemDetail,
    itemForm: getFormValues('item')(state),
    categories: item.categories,
    showDeleteModal: item.showDeleteModal,
    items: item.items,
    showNewCategoryModal: item.showNewCategoryModal,
    newCategory: item.newCategory,
    previousCategories: item.previousCategories,
    previousCategoryId: item.previousCategoryId,
    isTrack: item.isTrack,
    mustScrollTop: item.mustScrollTop,
    isSubmittingForm: item.isSubmittingForm,
    isDirtyForm: isDirty('modal_item_variants')(state),
    search: getFormValues('search')(state),
    taxes: item.taxes
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

const mapForm = {
  form: 'item',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(ItemForm))



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemForm.js